
export const INCOME_ORDERED = [
  'Едва сводим концы с концами, денег не хватает на продукты',
  'На продукты хватает, на одежду нет',
  'На продукты и одежду хватает, на технику и мебель нет',
  'На технику и мебель хватает, на большее денег нет',
  'Можем позволить только авто И можем позволить практически все'
];

export const EDUCATION_ORDERED = [
  'Полное среднее и ниже',
  'Среднее спец-ное/техническое или нач-ное профес-ное',
  'Высшее и незаконченное высшее'
];

export const SOCIAL_STATUS = [
  'Безработный',
  'Пенсионер',
  'Студент',
  'Рабочий',
  'Служащий',
  'Руководитель'
];
